import { createContext } from 'react';
import { IResourceDetailsContext } from './types';

export default createContext<IResourceDetailsContext>({
  resourceDetails: {},
  setResourceDetails: () => {},
});
